var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#627eea;}.cls-2{fill:#c0ccf7;}.cls-3{fill:#fff;}.cls-4{fill:#8198ee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836,
    transform: "translate(-96.03 231.836) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.814 111.804 230.204 117.274 230.204 276.01 231.814 277.616 305.497 234.062 231.814 111.804"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "231.814 111.804 158.131 234.062 231.814 277.617 231.814 200.572 231.814 111.804"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.814 291.568 230.907 292.673 230.907 349.218 231.814 351.868 305.541 248.036 231.814 291.568"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "231.814 351.867 231.814 291.567 158.131 248.035 231.814 351.867"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "231.814 277.616 305.496 234.063 231.814 200.572 231.814 277.616"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.132 234.063 231.814 277.616 231.814 200.572 158.132 234.063"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.be55bb5e4be1cf4ca4681b2ddac809ec.svg";
export { ForwardRef as ReactComponent };